import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/home"),
    meta: {
      title: "个人中心",
      index: 1
    }
  },
  {
    path: "/advertisement",
    name: "advertisement",
    component: () => import("@/views/advertisement/advertisement"),
    meta: {
      title: "精品推荐",
      index: 1
    }
  },
  {
    path: "/scheduling",
    name: "scheduling",
    component: () => import("@/views/scheduling/scheduling"),
    meta: {
      title: "排班",
      index: 1
    }
  },
  {
    path: "/accountSafe",
    name: "accountSafe",
    component: () => import("@/views/accountSafe/accountSafe"),
    meta: {
      title: "账户与安全",
      index: 2
    }
  },
  {
    path: "/verified",
    name: "verified",
    component: () => import("@/views/accountSafe/verified"),
    meta: {
      title: "实名认证",
      index: 3
    }
  },
  {
    path: "/driverAuth",
    name: "driverAuth",
    component: () => import("@/views/accountSafe/driverAuth"),
    meta: {
      title: "司机认证",
      index: 4
    }
  },
  {
    path: "/cardManage",
    name: "cardManage",
    component: () => import("@/views/accountSafe/cardManage"),
    meta: {
      title: "车辆管理",
      index: 5
    }
  },
  {
    path: "/cardManagedelete",
    name: "cardManagedelete",
    component: () => import("@/views/accountSafe/cardManagedelete"),
    meta: {
      title: "车辆管理",
      index: 6
    }
  },
  {
    path: "/cardAuth",
    name: "cardAuth",
    component: () => import("@/views/accountSafe/cardAuth"),
    meta: {
      title: "车辆认证",
      index: 7
    }
  },
  {
    path: "/sysSetting",
    name: "sysSetting",
    component: () => import("@/views/sysSetting/sysSetting"),
    meta: {
      title: "系统设置",
      index: 8
    }
  },
  {
    path: "/protocol",
    name: "protocol",
    component: () => import("@/views/protocol/protocol"),
    meta: {
      title: "隐私协议",
      index: 9
    }
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/views/aboutUs/aboutUs"),
    meta: {
      title: "关于我们",
      index: 10
    }
  },
  {
    path: "/signProtocol",
    name: "signProtocol",
    component: () => import("@/views/protocol/signProtocol"),
    meta: {
      title: "注册协议",
      index: 11
    }
  },
  {
    path: "/protocloDetails",
    name: "protocloDetails",
    component: () => import("@/views/protocol/protocloDetails"),
    meta: {
      title: "协议详情",
      index: 12
    }
  },
  {
    path: "/boardingPosition",
    name: "boardingPosition",
    component: () => import("@/views/firmInfo/boardingPosition"),
    meta: {
      title: "上车位置",
      index: 13
    }
  },
  {
    path: "/addPosition",
    name: "addPosition",
    component: () => import("@/views/firmInfo/addPosition"),
    meta: {
      title: "添加上车位置",
      index: 14
    }
  },
  {
    path: "/frimManage",
    name: "frimManage",
    component: () => import("@/views/firmInfo/frimManage"),
    meta: {
      title: "企业认证",
      index: 15
    }
  },
  {
    path: "/frimAuth",
    name: "frimAuth",
    component: () => import("@/views/firmInfo/frimAuth"),
    meta: {
      title: "企业认证",
      index: 16
    }
  },
  {
    path: "/city",
    name: "city",
    component: () => import("@/views/city/city"),
    meta: {
      title: "城市选择",
      index: 17,
	  keepAlive: true,
    }
  },
  {
    path: "/problem",
    name: "problem",
    component: () => import("@/views/problem/problem"),
    meta: {
      title: "常见问题",
      index: 18
    }
  },
  {
    path: "/assess",
    name: "assess",
    component: () => import("@/views/assess/assess"),
    meta: {
      title: "我的评价",
      index: 19
    }
  },
  {
    path: "/assessSuccess",
    name: "assessSuccess",
    component: () => import("@/views/assess/assessSuccess"),
    meta: {
      title: "评价成功",
      index: 20
    }
  },
  {
    path: "/personalInfo",
    name: "personalInfo",
    component: () => import("@/views/personalInfo/personalInfo"),
    meta: {
      title: "个人信息编辑",
      index: 21
    }
  },
  {
    path: "/personalInfogcs",
    name: "personalInfogcs",
    component: () => import("@/views/personalInfo/personalInfogcs"),
    meta: {
      title: "个人信息编辑",
      index: 22
    }
  },
  {
    path: "/personalInfolist",
    name: "personalInfolist",
    component: () => import("@/views/personalInfo/personalInfolist"),
	
    meta: {
      title: "个人信息",
      index: 23
    }
  },
  {
    path: "/setPassword",
    name: "setPassword",
    component: () => import("@/views/setPassword/setPassword"),
    meta: {
      title: "设置支付密码",
      index: 4
    }
  },
  {
    path: "/infoList",
    name: "infoList",
    component: () => import("@/views/infoList/infoList"),
    meta: {
      title: "消息列表",
      index: 4
    }
  },
  {
    path: "/infoDetails",
    name: "infoDetails",
    component: () => import("@/views/infoDetails/infoDetails"),
    meta: {
      title: "消息详情",
      index: 4
    }
  },
  {
    path: "/vehicleinsurance",
    name: "vehicleinsurance",
    component: () => import("@/views/accountSafe/vehicleinsurance"),
    meta: {
      title: "车辆保险管理",
      index: 4
    }
  },
  {
    path: "/vehicleinsurancelist",
    name: "vehicleinsurancelist",
    component: () => import("@/views/accountSafe/vehicleinsurancelist"),
    meta: {
      title: "车辆保险管理",
      index: 4
    }
  },
  {
    path: "/problemfeedback",
    name: "problemfeedback",
    component: () => import("@/views/Problemfeedback/problemfeedback"),
    meta: {
      title: "问题反馈",
      index: 4
    }
  },
  {
    path: "/problemfeedbacklist",
    name: "problemfeedbacklist",
    component: () => import("@/views/Problemfeedback/problemfeedbacklist"),
    meta: {
      title: "问题反馈",
      index: 4
    }
  },
  {
    path: "/questionfeedbackdetails/:id",
    name: "questionfeedbackdetails",
    component: () => import("@/views/Problemfeedback/questionfeedbackdetails"),
    meta: {
      title: "问题反馈详情",
      index: 4
    }
  },
  {
    path: "/allorders",
    name: "allorders",
    component: () => import("@/views/allorders/allorders"),
    meta: {
      title: "全部订单",
      index: 4
    }
  },
  {
    path: "/allorderslist",
    name: "allorderslist",
    component: () => import("@/views/allorders/allorderslist"),
    meta: {
      title: "订单详情",
      index: 4
    }
  },
  {
    path: "/allorderslist_driver",
    name: "allorderslist_driver",
    component: () => import("@/views/allorders/allorderslist_driver"),
    meta: {
      title: "订单详情",
      index: 4
    }
  },
  {
    path: "/modifymobilephone",
    name: "modifymobilephone",
    component: () => import("@/views/modifymobilephone/modifymobilephone"),
    meta: {
      title: "修改手机号",
      index: 4
    }
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: () => import("@/views/modifymobilephone/changePassword"),
    meta: {
      title: "修改密码",
      index: 4
    }
  },
  {
    path: "/electronic",
    name: "electronic",
    component: () => import("@/views/protocol/electronic"),
    meta: {
      title: "个人信息保护及隐私政策",
      index: 4
    }
  },
  {
    path: "/assessEvaluationDetails",
    name: "assessEvaluationDetails",
    component: () => import("@/views/assess/assessEvaluationDetails"),
    meta: {
      title: "评价成功详情",
      index: 4
    }
  },
  {
    path: "/platformusage",
    name: "platformusage",
    component: () => import("@/views/protocol/platformusage"),
    meta: {
      title: "平台使用协议",
      index: 4
    }
  },
  {
    path: "/userregistration",
    name: "userregistration",
    component: () => import("@/views/protocol/userregistration"),
    meta: {
      title: "用户注册及使用APP隐私协议",
      index: 4
    }
  },
  {
    path: "/homeManager",
    name: "homeManager",
    component: () => import("@/views/homeManager/homeManager"),
    meta: {
      title: "管理页面",
      index: 4,
	  // keepAlive: true,
    }
  },
  {
    path: "/XZvehicles",
    name: "XZvehicles",
    component: () => import("@/views/homeManager/XZvehicles"),
    meta: {
      title: "指派司机",
      index: 4
    }
  },

  {
    path: "/citys",
    name: "citys",
    component: () => import("@/views/city/citys"),
  },
 
 
];

const router = new VueRouter({
  routes
});

export default router;
